import { Component, OnInit } from '@angular/core';
import { UserManagementService } from 'app/services/user-management.service';
import { DataService } from 'app/services/data.service';
import { FrontEndService } from "../../services/front-end.service";

@Component({
    selector: 'app-view-feedback',
    templateUrl: './view-feedback.component.html',
    styleUrls: ['./view-feedback.component.scss']
})
export class ViewFeedbackComponent implements OnInit {
    fullScreenLoader = false;
    feedBack_data = [];

    constructor(
        private user_management_service: UserManagementService,
        public dataService: DataService,
        public front_end_service: FrontEndService,
    ) {
    }

    ngOnInit() {
        this.fullScreenLoader = true;
        this.user_management_service.getFeedback((resp) => {
            this.feedBack_data = resp.data;
            this.fullScreenLoader = false;
        });
    }

    changeFeedbackStatus(event, feedbackId) {
        this.fullScreenLoader = true;
        const feedbackStatus = {"status": event.value};
        this.user_management_service.changeFeedbackStatus(feedbackId, feedbackStatus, (resp) => {
            if (resp.status) {
                this.front_end_service.addToast(
                    "Success",
                    "feedback_status_changed_successfully",
                    "success"
                );
            }
            this.fullScreenLoader = false;
        });
    }
}
